module.exports = __webpack_public_path__ + "img/3@3x.8a6d77f9.png";